<rt-wysiwyg-inline-button
  [clipboardValue]="state.url!"
  [displayValue]="texts.linkName!"
  [class.expired]="state.expired || state.noTokenWarning"
  [rtTooltip]="state.expired ? ('app.wysiwyg.link.expired_tooltip' | translate) : undefined"
  #followDropdownTrigger="rtOverlayOrigin"
  variant="simple small-x"
  (click)="followDropdown.open = true"
  rt-overlay-origin
  [dropdownOpen]="followDropdown.open"
  [icon]="icons[state.type!]!"
></rt-wysiwyg-inline-button>

<ng-template
  #followDropdown="rtConnectedOverlay"
  [positions]="dropdownPositions"
  [origin]="followDropdownTrigger"
  [open]="dropdownOpened"
  [width]="280"
  (backdropClick)="followDropdown.open = false"
  rt-connected-overlay
  hasBackdrop
>
  <rt-dropdown>
    <rt-dropdown-header *ngIf="!state.expired">
      <div>
        <div class="subheading">{{ texts.dropdownTitle }}</div>
        <div class="heading text-wrap">{{ state.name || texts.linkName }}</div>
      </div>
    </rt-dropdown-header>

    <rt-dropdown-item [href]="state.url!" hrefTarget="_blank">
      <rt-icon name="open-in-new"></rt-icon>
      {{ 'app.wysiwyg.link.preview_link' | translate }}
    </rt-dropdown-item>
    <rt-dropdown-item (click)="remove(state)" variant="footer">
      <rt-icon name="remove-circle"></rt-icon>
      {{ 'app.common.remove' | translate }}
    </rt-dropdown-item>
  </rt-dropdown>
</ng-template>
